import React from 'react';

import T from 'prop-types';
import InfoBlock from './InfoBlock';
import { BatchResponse } from '../../../helpers/propTypes';
import { getData } from './processData';

const InfoBlocks = ({ data }) => {
  const { batchDetailsData, batchStatusData } = getData(data);
  return (
    <>
      <InfoBlock config={batchStatusData} marginTop="2rem" />
      <InfoBlock config={batchDetailsData} />
    </>
  );
};

InfoBlocks.propTypes = {
  data: T.shape(BatchResponse).isRequired
};

export default InfoBlocks;
